// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-radio-group > .v-input__control {
  flex-direction: column;
}
:where(.vuetify-styles) .v-radio-group > .v-input__control > .v-label {
  margin-inline-start: 16px;
}
:where(.vuetify-styles) .v-radio-group > .v-input__control > .v-label + .v-selection-control-group {
  padding-inline-start: 6px;
  margin-top: 8px;
}
:where(.vuetify-styles) .v-radio-group .v-input__details {
  padding-inline: 16px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VRadioGroup/VRadioGroup.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB","sourcesContent":[".v-radio-group > .v-input__control {\n  flex-direction: column;\n}\n.v-radio-group > .v-input__control > .v-label {\n  margin-inline-start: 16px;\n}\n.v-radio-group > .v-input__control > .v-label + .v-selection-control-group {\n  padding-inline-start: 6px;\n  margin-top: 8px;\n}\n.v-radio-group .v-input__details {\n  padding-inline: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
